import React from 'react';
import i18n from '../../i18n';
import { SelectField } from '@homeexchange/design';
import Availability from '../../models/Availability';
import moment from 'moment';
import { extendMoment } from 'moment-range';
var rangeMoment = extendMoment(moment);
var ExchangeTypeSelect = function (_a) {
    var onChange = _a.onChange, startOn = _a.startOn, endOn = _a.endOn, availabilities = _a.availabilities, exchangeType = _a.exchangeType, hasTypeExchangeError = _a.hasTypeExchangeError;
    var exchangeTypeShouldBeEnabled = function (optionValue) {
        if (!startOn ||
            !endOn ||
            !availabilities ||
            availabilities.length === 0 ||
            !exchangeType ||
            exchangeType === Availability.AVAILABLE.value) {
            return true;
        }
        var exchangeDateRange = rangeMoment.range(startOn, endOn);
        var matchingAvailability = availabilities.find(function (av) { return av.get('type') !== Availability.AVAILABLE.type && av.range().overlaps(exchangeDateRange); });
        if (!matchingAvailability) {
            return true;
        }
        return availabilities.some(function (av) {
            var _a;
            return av.range().overlaps(exchangeDateRange) &&
                (Availability.AVAILABLE.type === av.get('type') ||
                    ((_a = Availability.getAvailability(av.get('type'))) === null || _a === void 0 ? void 0 : _a.value) === optionValue);
        });
    };
    var reciprocalShouldBeEnabled = exchangeTypeShouldBeEnabled(Availability.RECIPROCAL.value);
    var gpShouldBeEnabled = exchangeTypeShouldBeEnabled(Availability.NON_RECIPROCAL.value);
    return (React.createElement(SelectField, { ariaLabel: i18n.t('exchange:exhange_type'), label: i18n.t('exchange:exhange_type'), placeholder: i18n.t('exchange:page.exchangeRequest.typeExchange.input.placeholder'), message: i18n.t('exchange:page.exchangeRequest.typeExchange.input.error'), items: [
            {
                id: Availability.AVAILABLE.value,
                value: Availability.AVAILABLE.value.toString(),
                displayedValue: i18n.t(Availability.AVAILABLE.selectPopupText),
                disabled: !(reciprocalShouldBeEnabled && gpShouldBeEnabled)
            },
            {
                id: Availability.RECIPROCAL.value,
                value: Availability.RECIPROCAL.value.toString(),
                displayedValue: i18n.t(Availability.RECIPROCAL.selectPopupText),
                disabled: !reciprocalShouldBeEnabled
            },
            {
                id: Availability.NON_RECIPROCAL.value,
                value: Availability.NON_RECIPROCAL.value.toString(),
                displayedValue: i18n.t(Availability.NON_RECIPROCAL.selectPopupText),
                disabled: !gpShouldBeEnabled
            }
        ], onChange: function (value) { return onChange(value ? Number(value) : undefined); }, status: hasTypeExchangeError ? 'error' : undefined, value: exchangeType === undefined ? undefined : exchangeType.toString() }));
};
export default ExchangeTypeSelect;
